"use client";

import { I18nextProvider } from "react-i18next";
import { Provider as ReduxProvider } from "react-redux";
import { ThemeProvider } from "@revoo/design-system/providers/ThemeProvider";
import { PersistGate } from "redux-persist/integration/react";

import { revooTheme } from "@revoo/design-system/themes/revoo/revooTheme";
import AnalyticsProvider from "@/libs/shared/analytics/AnalyticsProvider";

import { makeStore } from "../store";
import { registerReduxPersistor } from "../reduxPersistFlush";
import type { Analytics } from "firebase/analytics";
import type { FC } from "react";

import "react-day-picker/dist/style.css";
import "react-calendar/dist/Calendar.css";
import "react-international-phone/style.css";

const store: any = makeStore();
registerReduxPersistor(store.__persistor);

interface ProvidersProps {
  children: React.ReactNode;
  analytics?: Analytics;
  staticImages?: any;
  i18n?: any;
  Logo: FC;
  LogoReduced: FC;
}

export function Providers({
  children,
  analytics,
  staticImages,
  i18n,
  Logo,
  LogoReduced,
}: ProvidersProps) {
  return (
    <ReduxProvider store={store}>
      <I18nextProvider i18n={i18n}>
        <AnalyticsProvider analytics={analytics}>
          <PersistGate persistor={store.__persistor}>
            <ThemeProvider
              theme={{
                ...revooTheme,
                images: staticImages,
                Logo,
                LogoReduced,
              }}
            >
              {children}
            </ThemeProvider>
          </PersistGate>
        </AnalyticsProvider>
      </I18nextProvider>
    </ReduxProvider>
  );
}
